import React from 'react'
import PropTypes from 'prop-types'

import { Square } from 'Components/Blocks/_Legacy'
import ProjectsSwiper from 'Components/Blocks/_Legacy/ProjectsSwiper'

import { Container } from './styles'

function Projects({ data }) {
  return (
    <Container>
      <ProjectsSwiper data={data} />

      <Square
        angle={-30}
        horizontalAlign={[-550, null]}
        verticalAlign={[0, null]}
      />

      <Square
        angle={15}
        horizontalAlign={[null, -500]}
        verticalAlign={[0, null]}
      />
    </Container>
  )
}

Projects.defaultProps = {
  data: {},
}

Projects.propTypes = {
  data: PropTypes.object,
}

export default Projects
